import 'bootstrap'
import './sass/app.scss'
import 'owl.carousel'
import 'magnific-popup';

$(document).ready(function () {
    $('.gallery').magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
        }
        // other options
    });
    $('.loop').owlCarousel({
        dots: true,
        nav: true,
        navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
        center: true,
        items: 1,
        loop: true,
        margin: 20,
        responsive: {
            600: {
                items: 2
            }
        }
    });
    $('.opinions').owlCarousel({
        dots: true,
        nav: true,
        navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
        center: true,
        items: 1,
        loop: true,
        margin: 20,
        responsive: {
            600: {
                items: 3
            }
        }
    });

    $('.navbar-wrap > nav > button').on('click', function () {
        $('.navbar-wrap').toggleClass('extended');
    });

});

